/* Maison Fourrure — Luxury Interactions
   Scroll reveal, sticky header, parallax
   Vanilla JS — no dependencies */

(function () {
  'use strict';

  /* ── Scroll-reveal ── */
  function initScrollReveal() {
    var reveals = document.querySelectorAll('[data-reveal]');
    if (!reveals.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseInt(el.getAttribute('data-reveal-delay') || '0', 10);
            setTimeout(function () {
              el.classList.add('is-revealed');
            }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    reveals.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Sticky header transparency ── */
  function initStickyHeader() {
    var headerGroup = document.getElementById('header-group');
    if (!headerGroup) return;

    var scroller = document.querySelector('.page-wrapper') || window;
    var threshold = 60;

    function onScroll() {
      var scrollTop = scroller.scrollTop !== undefined ? scroller.scrollTop : window.scrollY;
      if (scrollTop > threshold) {
        headerGroup.classList.add('mf-header--scrolled');
      } else {
        headerGroup.classList.remove('mf-header--scrolled');
      }
    }

    scroller.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ── Run on DOMContentLoaded ── */
  function init() {
    initScrollReveal();
    initStickyHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
